
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import regular from "@/common/regular";
import { getAuthIdempotence } from "@/api/api-basic";
import { rechargeCashCard } from "@/api/api-non-name";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiHairpinManage extends Vue {
  private FormData: objAny = {};
  // private isGetCode = true;
  // private codeText = "获取验证码";
  // private codeTime = 60;
  // private setTime = false;
  isReadSuccess = false;
  private formInline: objAny = {
    cardPhysicalNumber: "",
    cardSerialNumber: "",
    accountBalance: 0,
    contactName: "",
    phoneNo: "",
    remarks: "",
    idemToken: "",
    bussType: 4,
    accountPkId: "",
    cardPkId: "",
    rechargeAmount: "",
    accountType: ""
  };
  private ruleInline = {
    verCode: [],
    rechargeAmount: [
      {
        required: true,
        trigger: "blur",
        validator: regular.money
      }
    ]
  };
  private loading = false;

  public handleSubmit() {
    this.FormData.validate((valid: boolean) => {
      if (valid) {
        this.rechargeCard();
      } else {
        this.$nextTick(() => {
          console.log("error");
        });
      }
    });
  }

  async rechargeCard() {
    const allMoney =
      Number(this.formInline.accountBalance) +
      Number(this.formInline.rechargeAmount);
    if (allMoney > 99999) {
      this.$Message.error(i18n.t("nonRealNameCardManagement.allMoneyMax"));
      return;
    }
    const params: objAny = {
      accountPkId: this.formInline.accountPkId,
      cardPkId: this.formInline.cardPkId,
      rechargeAmount: this.formInline.rechargeAmount,
      idemToken: this.formInline.idemToken,
      accountType: this.formInline.accountType
    };
    this.loading = true;
    const ret = await rechargeCashCard(params);
    if (ret.status === this.$config.apiStatus) {
      if (!ret || !ret.data) {
        return;
      }
      this.$Modal.success({
        title: i18n.t("nonRealNameCardManagement.allMoneyMax") + "",
        content: `<h2>${i18n.t("balance")}：${
          ret.data[0].afterBalance
        } ${i18n.t("yuan")}</h2>`,
        onOk: () => {
          this["$router"].push(
            "/member-management/non-real-name-card-management"
          );
        }
      });
    } else {
      this.getAuthIdempotence();
    }
    this.loading = false;
  }
  async getAuthIdempotence() {
    const ret = await getAuthIdempotence({});
    if (ret.status == this["$config"].apiStatus) {
      this.formInline.idemToken = ret.data[0] || "";
    }
  }
  mounted() {
    const item = this["$common"].get("non-real-name-card-management-item");

    this.formInline.cardPkId = item.cardPkId;
    this.formInline.cardPhysicalNumber = item.cardPhysicalNumber;
    this.formInline.accountPkId = item.accountPkId;
    this.formInline.contactName = item.contactName;
    this.formInline.phoneNo = item.phoneNo;
    this.formInline.remarks = item.remarks + "";
    this.formInline.accountBalance = item.accountBalance + "";
    this.formInline.cardSerialNumber = item.cardSerialNumber;
    this.formInline.oprPkId = item.oprPkId;
    this.formInline.accountType = item.accountType;

    if (item.cardStatus === 1) {
      this.isReadSuccess = true;
    } else {
      this.isReadSuccess = false;
    }
    if (!this.FormData.$el) {
      this.$nextTick((): void => {
        this.FormData = this.$refs["formInline"];
      });
    }
    this.getAuthIdempotence();
  }
}
